export default __webpack_public_path__ + "static/media/scb.918163c7.svg";